import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { CircularProgress, Grid } from "../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";
import { PreSubmissionConfigurationModel } from "../../models/BatchMessage/BatchMessageDetailModel";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { TemplateListDataGrid } from "../TemplateListDataGrid/TemplateListDataGrid";
import "./ScheduledTemplateList.css";
import { TemplateType } from "../../common/enum";
import { GetMyScheduledTemplates } from "../../api/batchNotificationController";

export const ScheduledTemplateList: React.FC = () => {
	const [error, setError] = React.useState<string>("");
	const [templateList, setTemplateList] = React.useState<
		PreSubmissionConfigurationModel[]
	>([]);
	const [mounted, setMounted] = React.useState<boolean>(false);
	const strings = useGetComponentStringsContext().ScheduledTemplateList;
	const history = useHistory();

	const [updateRequired, setUpdateRequired] = React.useState<boolean>(true);

	useEffect(() => {
		const getAllTemplates = async () => {
			try {
				const res = await GetMyScheduledTemplates();
				if (res.error) {
					setError(res.error);
				} else {
					setTemplateList(res.responseObj ? res.responseObj : []);
					setMounted(true);
					setUpdateRequired(false);
				}
			} catch (err) {
				console.error(err);
				setError(err);
			}
		};

		if (updateRequired) {
			setTimeout(() => {
				getAllTemplates();
			}, 1000);
		}
	}, [updateRequired]);

	const onNotificationIdChange = async (
		preSubmissionConfigurationDetail: PreSubmissionConfigurationModel
	) => {
		const pathName =
			preSubmissionConfigurationDetail.type ===
			TemplateType[TemplateType.BatchMessaging]
				? "/batchMessageConfiguration/"
				: "/requestForHelpConfiguration/";
		history.push({
			pathname:
				pathName +
				preSubmissionConfigurationDetail.partitionKey +
				"/" +
				preSubmissionConfigurationDetail.id,
			state: {
				requestFromPath: "scheduledTemplates",
			},
		});
	};

	return (
		<div>
			{!mounted && error ? (
				<ErrorPage message={strings.templateListErrorMessage} />
			) : !mounted ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<>
					<Grid container spacing={3}>
						<Grid item xs={6}></Grid>
						<Grid item xs={12}>
							<TemplateListDataGrid
								templateList={templateList}
								displayStatusColumn={true}
								scheduledTemplate={true}
								title={strings.title}
								onNotificationIdChange={(
									model: PreSubmissionConfigurationModel
								) => onNotificationIdChange(model)}
								onApproveTemplateSelectedId={() => {}}
								onRejectTemplateSelectedId={() => {}}
								messageCancelEnabled={true}
								templateUpdateRequired={setUpdateRequired}
								setMounted={setMounted}
							/>
						</Grid>
					</Grid>
				</>
			)}
		</div>
	);
};
